// Gedeelde helpers voor BE/NL decimaal-invoer: accepteert komma + punt,
// bewaart trailing komma tijdens typen, toont waarde in BE-formaat (komma).
//
// Gebruik:
//   const [aantal, setAantal] = useState('');
//   <input type="text" inputMode="decimal"
//     value={fmtDec(aantal)}
//     onChange={e => setAantal(parseRawDec(e.target.value))}
//     placeholder="0,00" />
//   ...
//   const saved = pf(aantal);  // bij submit naar backend

/** Converteer een ingegeven string "12,50" of "12.50" → ruwe normalized string "12.50" (punt).
 *  Leeg → lege string. Ongeldige invoer → behoudt de originele string (laat user corrigeren). */
export const parseRawDec = (raw) => {
  if (raw === null || raw === undefined || raw === '') return '';
  return String(raw).replace(',', '.');
};

/** Toon waarde in BE-formaat (punt → komma) zodat de UI altijd Belgisch oogt. */
export const fmtDec = (v) => {
  if (v === null || v === undefined || v === '') return '';
  return String(v).replace('.', ',');
};

/** parseFloat die komma als decimaal-scheider accepteert. Returneert 0 bij leeg/NaN. */
export const pf = (v) => {
  if (v === null || v === undefined || v === '') return 0;
  const n = parseFloat(String(v).replace(',', '.'));
  return isNaN(n) ? 0 : n;
};

/** parseInt die komma-strings accepteert. Returneert 0 bij leeg/NaN. */
export const pi = (v) => {
  if (v === null || v === undefined || v === '') return 0;
  const n = parseInt(String(v).replace(',', '.'), 10);
  return isNaN(n) ? 0 : n;
};

/** Format een getal als EUR met komma-decimaal: 12.5 → "€ 12,50" */
export const fmtEur = (n, digits = 2) => {
  const num = pf(n);
  return `€ ${num.toFixed(digits).replace('.', ',')}`;
};

/** Format getal zonder € met komma-decimaal. Bv. 12.5 → "12,50" */
export const fmtNum = (n, digits = 2) => {
  const num = pf(n);
  return num.toFixed(digits).replace('.', ',');
};
